export default {
  en:{
    completesetup: {
      heading: {
        h1: 'Complete your profile',
        personal: 'Personal',
        payment: 'Payment'
      },
      text: 'Hey, thank you for taking part in the ATC training community. Complete your profile and you are nearly ready for departure.',
      tryfree: 'I want to try the ATC simulator for 3 days',
      optional: 'Optional',
      optionalpassword: 'You signed up using a third-party service. Setting a password is optional, but it allows you to log in without that service.',
      payment: {
        add: 'Add a payment method',
        info: 'It is <u>not mandatory</u> to add a payment method immediately. You can always do that later.'
      },
      profilecompleted: 'Profile completed'
    }
  },
  de:{
    completesetup: {
      heading: {
        h1: 'Profil vervollständigen',
        personal: 'Persönlich',
        payment: 'Zahlung'
      },
      text: 'Hey, danke, dass du Teil der ATC-Trainingscommunity bist. Vervollständige dein Profil und du bist fast startklar.',
      tryfree: 'Ich möchte den ATC-Simulator 3 Tage lang ausprobieren',
      optional: 'Optional',
      optionalpassword: 'Du hast dich über einen Drittanbieterdienst angemeldet. Das Festlegen eines Passworts ist optional, ermöglicht dir jedoch die Anmeldung ohne diesen Dienst.',
      payment: {
        add: 'Zahlungsmethode hinzufügen',
        info: 'Es ist <u>nicht erforderlich</u>, sofort eine Zahlungsmethode hinzuzufügen. Du kannst das später immer noch tun.'
      },
      profilecompleted: 'Profil vervollständigt'
    }
  },
  es:{
    completesetup: {
      heading: {
        h1: 'Completa tu perfil',
        personal: 'Personal',
        payment: 'Pago'
      },
      text: 'Hola, gracias por ser parte de la comunidad de entrenamiento de ATC. Completa tu perfil y estarás casi listo para despegar.',
      tryfree: 'Quiero probar el simulador de ATC durante 3 días',
      optional: 'Opcional',
      optionalpassword: 'Te registraste usando un servicio de terceros. Establecer una contraseña es opcional, pero te permite iniciar sesión sin ese servicio.',
      payment:{
        add: 'Agregar un método de pago',
        info: '<u>No es obligatorio</u> agregar un método de pago de inmediato. Siempre puedes hacerlo más tarde.'
      },
      profilecompleted: 'Perfil completado'
    }
  },
  uk: {
    completesetup: {
      heading: {
        h1: 'Завершіть свій профіль' ,
        personal: 'Особисті дані',
        payment: 'Оплата'
      },
      text: 'Привіт, дякуємо вам за участь у спільноті навчання ATC. Завершіть свій профіль, і ви майже готові до вильоту.',
      tryfree: 'Я хочу спробувати симулятор ATC протягом 3 днів',
      optional: 'Необов\'язково',
      optionalpassword: 'Ви зареєструвалися, використовуючи сторонній сервіс. Встановлення пароля є необов\'язковим, але це дозволяє вам увійти без цього сервісу.',
      payment:{
        add: 'Додати спосіб оплати',
        info: '<u>Не обов\'язково</u> відразу додавати спосіб оплати. Ви завжди можете зробити це пізніше.'
      },
      profilecompleted: 'Профіль завершено'
    }
  }
}
